<template>
	<div >
		<div class="d-flex flex-row">
			<button v-if="showNavigation" class="btn-icon btn btn-arrow" @click="moveAndFocus(0)"> <i class="material-icons ">keyboard_arrow_left</i></button>
			<div ref="imageScroll" class="scroll-area scrolls" id="scrolls-style">
				<div class="background-flex">
					<div :id="item.order" class="bg-list pr-1" v-for="(item, index) in items" :key="index"
						@click="setSelectedBackground(item)">
						<div class="image-background-item" :class="selectedBackgroundClass(item)">
							<img class="imgBg" ref="bgImage" :src="item.file_path" height="90" width="177" />
						</div>
					</div>
				</div>
			</div>
			<button v-if="showNavigation" class="btn-icon btn btn-arrow" @click="moveAndFocus(1)"> <i class="material-icons ">keyboard_arrow_right</i></button>
		</div>
	</div>
</template>


<script>
import layoutsApi from '@/api/layouts';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'compositionLayout',
	data() {
		return {
			title: 'Layout',
			viewMenu: false,
			top: '0px',
			left: '0px',
			page: 1,
			limit: 25,
			orderBy: 'order',
			sortBy: 'asc',
			keyword: '',
			totalItems: 0,
			lastPage: 0,
			isAll: false,
			items: [],
			selected: null,
			isUpload: false,
			valueVideo: '',
			audioOptions: [],
			videoOptions: [],
			programOptions: [],
			detailsDebug: '',
			activeBtn: '',
			selectedBackground: null,
			isDeleteEnable: false,
			showNavigation: false,
		};
	},
	computed: {
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	methods: {
		fetch(reset = false, page) {
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.showNavigation = items.length >= 1 || false;
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			layoutsApi.getList(params, callback, errorCallback);
		},
		moveAndFocus(isRight) {
			// const imgId = 0;
			if (isRight) {
				if (this.imgIndex <= this.totalItems - 1) {
					this.imgIndex++;
					document.getElementById(this.imgIndex).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				} else {
					this.imgIndex = 1;
					document.getElementById(this.imgIndex).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				}
			} else {
				// eslint-disable-next-line no-lonely-if
				if (this.imgIndex >= 1) {
					this.imgIndex--;
					document.getElementById(this.imgIndex).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				} else {
					this.imgIndex = this.totalItems;
					document.getElementById(this.imgIndex).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				}
			}
		},
		selectAndFocus(id) {
			// eslint-disable-next-line eqeqeq
			const selectedBackground = this.items.find(item => item.order == id);
			this.setSelectedBackground(selectedBackground);
		},
		setSelectedBackground(item) {
			this.selectedBackground = item;
			const params = {
				id: item.id,
				canvas_x: item.canvas_x,
				canvas_y: item.canvas_y,
				canvas_width: item.canvas_width,
				canvas_height: item.canvas_height,
				window_width: item.window_width,
				window_height: item.window_height,
			};
			this.$emit('selectLayout', params);
		},
		selectedBackgroundClass(background) {
			return this.selectedBackground === background ? 'active' : '';
		},
		setDefaultBackground() {
			if (this.backgrounds.length > 0) this.setSelectedBackground(this.backgrounds[0]);
		},
		setActiveBackground() {
			this.$emit('setBackgroundConfig', this.selectedBackground.path);
		},
	},
	created() {
		this.fetch();
	},
};

</script>

<style scoped>
img {
	height: 90px;
}
</style>
